<template>
  <div class="mobile-view">
    <RouterView />

    <transition name="slide-up">
      <QrScan
        v-if="overlayStore.showQrScan && showScanner"
        @close="handleClose"
        @scanned="handleScanned"
        class="qrscan_view"
      />
    </transition>

    <Navbar class="navbar_view" @scanRequest="requestCameraAccess" />
  </div>
</template>

<script setup>
import { RouterView, useRouter } from 'vue-router'
import Navbar from '@/components/general/nav_bar.vue'
import QrScan from '@/components/scanner/qr_scan.vue'
import { useOverlayStore } from '@/stores/overlay'
import { ref } from 'vue'

const overlayStore = useOverlayStore()
const router = useRouter()
const showScanner = ref(false)

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

const requestCameraAccess = async () => {
  console.log("Demande d'accès à la caméra...")

  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } })
    stream.getTracks().forEach(track => track.stop())

    await sleep(300)
    showScanner.value = true
    overlayStore.toggleQrScan(true)

  } catch (e) {
    console.warn('Permission caméra refusée')
    alert("Vous devez autoriser l'accès à la caméra pour scanner un QR code.")
  }
}

const handleClose = () => {
  showScanner.value = false
  overlayStore.toggleQrScan(false)
}

const handleScanned = async (scannedText) => {
  console.log('Contenu scanné :', scannedText)
  handleClose()

  await sleep(300) // transition clean avant la redirection
  router.push('/varibox')
}
</script>

<style scoped>
.mobile-view {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.qrscan_view {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 99vh;
  z-index: 2000;
}

.navbar_view {
  z-index: 1;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
}
</style>